import { debounce } from 'lodash'
import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Icon } from '@iconify/react'
import { Input, Select, Space, Tag } from 'antd'

import FilterDrawer from './candidate-filter-drawer'
import { CANDIDATE_STATUS } from './candidate-status-tab-list'
import { setActiveJobId, setActiveTab } from '../store/candidate.slice'
import { getListJobs, jobState } from '../../jobs/store/job.slice'
import { searchCandidate } from '../../jobApplications/store/jobApplicant.slice'
import { TalentToolbar } from '../../talent/TalentToolbar'
import styles from '../candidate.module.css'

const PanelHeader = () => {
    const [drawerVisible, setDrawerVisible] = useState(false)
    const dispatch = useDispatch()
    const { activeTab, jobId } = useSelector((state) => state.candidateSlice)
    const { jobList, filter } = useSelector(jobState)
    const [searchValue, setSearchValue] = useState('')

    const closeDrawer = () => setDrawerVisible(false)

    const debouncedSearch = useMemo(
        () =>
            debounce((value) => {
                dispatch(searchCandidate(value))
            }, 400),
        [dispatch]
    )

    useEffect(() => () => debouncedSearch.cancel(), [debouncedSearch])

    useEffect(() => {
        dispatch(
            getListJobs({
                limit: 100,
                skip: 0,
                search: '',
                filter: {},
            })
        )
    }, [dispatch])

    return (
        <>
            <TalentToolbar>
                <div className={styles.tabToolbarInline}>
                    <div className={styles.controls}>
                        <div className={styles.searchWrap}>
                            <Input
                                allowClear
                                size="large"
                                placeholder="Search candidate by name, email, or phone"
                                className={styles.search}
                                prefix={
                                    <Icon
                                        icon="mdi:magnify"
                                        width={18}
                                        height={18}
                                    />
                                }
                                value={searchValue}
                                onChange={(e) => {
                                    const value = e.target.value
                                    setSearchValue(value)
                                    debouncedSearch(value)
                                }}
                            />
                        </div>

                        <Select
                            value={activeTab || null}
                            className={styles.filterSelect}
                            placeholder="Search status"
                            onChange={(value) =>
                                dispatch(setActiveTab(value))
                            }
                            allowClear
                            showSearch
                            optionFilterProp="label"
                            filterOption={(input, option) => {
                                const status = CANDIDATE_STATUS.find(
                                    (item) => item.value === option?.value
                                )
                                const label =
                                    status?.label || String(option?.value || '')
                                return label
                                    .toLowerCase()
                                    .includes(input.trim().toLowerCase())
                            }}
                            options={CANDIDATE_STATUS.map((status) => ({
                                label: (
                                    <Space>
                                        <Tag color={status.color}>
                                            {status.label}
                                        </Tag>
                                    </Space>
                                ),
                                value: status.value,
                            }))}
                        />

                        <Select
                            value={jobId || null}
                            className={styles.filterSelect}
                            placeholder="Search job"
                            onChange={(value) => {
                                dispatch(setActiveJobId(value))
                                dispatch(
                                    getListJobs({
                                        limit: 100,
                                        skip: 0,
                                        filter: {
                                            ...filter,
                                            jobId: value,
                                        },
                                    })
                                )
                            }}
                            allowClear
                            showSearch
                            optionFilterProp="label"
                            options={(jobList || []).map((job) => ({
                                label: job.title,
                                value: job._id,
                            }))}
                        />
                    </div>
                </div>
            </TalentToolbar>

            <FilterDrawer visible={drawerVisible} onClose={closeDrawer} />
        </>
    )
}

export default PanelHeader
